export default __webpack_public_path__ + "static/media/maps-and-flags.9929c41a.svg";